var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.desktopTracking = {};
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var BaseCitySelect = require('../../../../include/_js/BaseCitySelect');

        var CitySelect = function (_BaseCitySelect) {
            _inherits(CitySelect, _BaseCitySelect);

            function CitySelect() {
                _classCallCheck(this, CitySelect);

                return _possibleConstructorReturn(this, (CitySelect.__proto__ || Object.getPrototypeOf(CitySelect)).apply(this, arguments));
            }

            _createClass(CitySelect, [{
                key: "init",
                value: function init() {
                    var selfSelect = this;
                    // ex. $mainCitySelect
                    this.cityElement = new hSelect({
                        selector: '#hSelectMainCity',
                        theme: 'easy',
                        checkWidth: false,
                        onItemClick: function onItemClick($elem) {
                            var val = $elem.data('value');
                            if (val !== this.value) {
                                var view = $elem.html();
                                if ("undefined" !== typeof $elem.data('text') && "" !== $elem.data('text')) {
                                    view = $elem.data('text');
                                }
                                this.$items.find('.h-select-item__active').removeClass('h-select-item__active');
                                $elem.addClass('h-select-item__active');
                                this.onChange(val, view, $elem);
                                $(window).trigger('onLocation', app.cities[val]);
                            }

                            selfSelect.lockMainMenuOpen();
                            setTimeout(function () {
                                selfSelect.unlockMainMenuOpen();
                            }, 500);
                            this.hide();
                        },
                        onChange: function onChange(ui) {
                            var cityName = ui.$face.text().trim();
                            $('.p-light').addClass('p-light-anim');
                            selfSelect.setCity(cityName, !selfSelect.isLocatedUser(), true);
                        },
                        onBodyClick: function onBodyClick($e) {
                            for (var i in $e.target.classList) {
                                if ($e.target.classList[i] === "deny") {
                                    return false;
                                }
                            }
                            return true;
                        }
                    });
                    this.attachListeners();
                    this.checkLocation();
                }
            }, {
                key: "attachListeners",
                value: function attachListeners() {
                    var _this2 = this;

                    var selfSelect = this;
                    $(window).on('onLocation', function (event, city) {
                        if (!city) {
                            return false;
                        }
                        _this2.fitSiteToCity(city.id, false);
                        window.tracking.callTrackingRefresh();
                    });

                    $('body').on('click', '.city-detected__buttons span', function () {
                        var $self = $(this);
                        if ($self.hasClass('deny')) {
                            selfSelect.cityElement.show();
                        } else {
                            var cityName = $('#city-detected-form .city-detected__name').data('city');
                            selfSelect.setCity(cityName, !selfSelect.isLocatedUser(), true);
                        }
                        $('#city-detected-form').hide();

                        // lock menu при выборе города
                        selfSelect.lockMainMenuOpen();
                        setTimeout(function () {
                            selfSelect.unlockMainMenuOpen();
                        }, 500);
                    });
                }

                /**
                 * @inheritDoc
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {
                    var city = this.findById(cityId);
                    if (!city) {
                        return false;
                    }

                    // Установка контактов
                    this.drawContacts(city.id);

                    if (onlyContacts) {
                        return;
                    }

                    // toggle promo images with cities restrictions
                    var $promoImages = $('.promo-img--with-cities');
                    if ($promoImages.length) {
                        $promoImages.each(function (index, promoImg) {
                            var cities = promoImg.dataset.cities || '';
                            var cityIds = [];
                            cities.split(',').forEach(function (cityId) {
                                cityIds.push(Number(cityId));
                            });
                            var isHidden = cityIds.indexOf(city.id) === -1;
                            promoImg.classList.toggle('hidden', isHidden);
                        });
                    }

                    // Смена города в списке стран
                    $('.hot-slider .hot_fake_options .hot_fake_option[data-city=' + city.id + ']').trigger('click');
                    // выбираем город в списке стран с ценами
                    $('.country-tabs ul li[data-dc-id=' + city.id + '] a').trigger('click');
                    // меняем город по умолчанию в форме подписки
                    $('.subscription-radios input[value=' + city.id + ']').trigger('click');

                    // смена города в главном селекте
                    this.cityElement.set(city.id, true); // change trigger disabled
                    $('.btn-instagram').attr('href', city.instagram);

                    // Подмена цен
                    $.post('/country/get-prices', {}, function (dataResult) {
                        var result = '';
                        var minPrice = void 0;
                        var i = void 0;
                        for (i in dataResult) {
                            minPrice = dataResult[i].minPrice ? '&nbsp;<span class="menu_tour_price">(от ' + dataResult[i].minPrice + ')</span>' : '';
                            result += '<li class="changed pull-left replace-country">' + '<a href="/tours/' + dataResult[i].name_en + '">' + '<img class="country-icon" src="/img/flag/' + dataResult[i].code + '.svg" />' + '<span class="country-name bordered-brown gotham-regular">' + dataResult[i].name + minPrice + '</span>' + '</a>' + '</li>';
                        }
                        $('#tours-menu .replace-country').remove();
                        $('#tours-menu').prepend(result);
                    });

                    // Смена праздничных графиков
                    if (city.hasHoliday) {
                        // показать ссылку на праздники
                        $('[data-role="work-schedule"]').addClass('hidden');
                        $('[data-role="holiday-schedule"]').removeClass('hidden');
                    } else {
                        // показать рабочее время
                        $('[data-role="holiday-schedule"]').addClass('hidden');
                        $('[data-role="work-schedule"]').removeClass('hidden');
                    }
                }

                /**
                 * @inheritDoc
                 */

            }, {
                key: "showDetectedCityConfirm",
                value: function showDetectedCityConfirm(cityId) {
                    if (this.contactExist(cityId)) {
                        var _city = this.findById(cityId);
                        var $eCity = $('#city-detected-form');
                        $eCity.find('.city-detected__name').text(_city.name).data('city', _city.name);
                        $eCity.show();
                    }
                }
            }, {
                key: "isLocationConfirmPromptEnabled",
                value: function isLocationConfirmPromptEnabled() {
                    return !this.isLocatedUser() || $('#city-detected-form').is(':visible');
                }

                /**
                 * @protected
                 */

            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {
                    var city = this.getCurrent();
                    if (city.scheme) {
                        $('.header-city-scheme').removeClass('hidden');
                    } else {
                        $('.header-city-scheme').addClass('hidden');
                    }
                }

                /**
                 * @param cityId
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "drawContacts",
                value: function drawContacts(cityId) {
                    if (!this.contactExist(cityId)) {
                        return false;
                    }

                    var city = this.findById(cityId);
                    $('.current-city-phone-wrapper').each(function () {
                        var type = this.getAttribute('data-type');
                        this.innerHTML = city.getPhoneView(type);
                    });

                    $('.header-city-scheme').data('city', city.id);
                    $('.content-city-scheme').data('city', city.id);
                    $('.aside-popup-buttons .popup-social-facebook a').attr('href', city.socials.facebook);
                    $('.aside-popup-buttons .popup-social-instagram a').attr('href', city.socials.instagram);
                }

                /**
                 * Блокирует открытие меню при открытой модалке подтвержения/выбора города
                 * @protected
                 */

            }, {
                key: "lockMainMenuOpen",
                value: function lockMainMenuOpen() {
                    this.mainMenuOpenLock = true;
                }

                /**
                 * @protected
                 */

            }, {
                key: "unlockMainMenuOpen",
                value: function unlockMainMenuOpen() {
                    this.mainMenuOpenLock = false;
                }

                /**
                 * @return {boolean}
                 * @public
                 */

            }, {
                key: "isMainMenuOpenLocked",
                value: function isMainMenuOpenLocked() {
                    return this.mainMenuOpenLock;
                }
            }]);

            return CitySelect;
        }(BaseCitySelect);

        window.citySelect = new CitySelect();
        citySelect.init();
    }, { "../../../../include/_js/BaseCitySelect": 2 }], 2: [function (require, module, exports) {
        var Location = require('./Location');
        window.CityItem = require('./CityItem');
        var pixelTracker = require('./PixelTracker');
        var CITY_ALMATY = 1;

        var BaseCitySelect = function () {
            function BaseCitySelect() {
                _classCallCheck(this, BaseCitySelect);

                this.location = new Location();
                this.cityElement = null; // main site city
                /**
                 * @type {boolean}
                 * @protected
                 */
                this.mainMenuOpenLock = false;
            }

            /**
             * @protected
             */


            _createClass(BaseCitySelect, [{
                key: "checkLocation",
                value: function checkLocation() {
                    var _this3 = this;

                    if (this.isLocatedUser()) {
                        this.fitSiteToCity(app.city.id, true);
                        // fb counter
                        this.initializePixel(app.realCity.name);
                    } else {
                        window.addEventListener('load', function () {
                            if (window.app.isGeolocationEnabled) {
                                _this3.location.get(function (locatedCityName) {
                                    _this3.setCity(locatedCityName, true, true);
                                    _this3._onLocationCallback(locatedCityName);
                                });
                            } else {
                                _this3._onLocationCallback('');
                            }
                        }, { once: true });
                    }
                }

                /**
                 *
                 * @param {string} locatedCityName
                 * @private
                 */

            }, {
                key: "_onLocationCallback",
                value: function _onLocationCallback(locatedCityName) {
                    // fb counter
                    this.initializePixel(locatedCityName);

                    var detectedCity = locatedCityName !== '' ? CityItem.findByName(locatedCityName) : null;
                    if (!detectedCity) {
                        detectedCity = this.getDefaultCity();
                    }

                    this.showDetectedCityConfirm(detectedCity.id);
                }

                /**
                 * @deprecated
                 * @return {CityItem|null}
                 */

            }, {
                key: "getCurrent",
                value: function getCurrent() {
                    return CityItem.getCurrent();
                }

                /**
                 * @deprecated
                 * @param {number} cityId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findById",
                value: function findById(cityId) {
                    return CityItem.findById(cityId);
                }

                /**
                 * @deprecated
                 * @param {string} cityName
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByName",
                value: function findByName(cityName) {
                    return CityItem.findByName(cityName);
                }

                /**
                 * @deprecated
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "contactExist",
                value: function contactExist(cityId) {
                    return CityItem.contactExist(cityId);
                }

                /**
                 * @return {boolean}
                 */

            }, {
                key: "isLocatedUser",
                value: function isLocatedUser() {
                    return app.city.name && app.realCity.name;
                }

                /**
                 * @param {string} cityName
                 * @param {boolean} isReal
                 * @param {boolean|undefined} runCallback
                 */

            }, {
                key: "setCity",
                value: function setCity(cityName, isReal, runCallback) {
                    var _this4 = this;

                    app.city.name = cityName;
                    if (isReal) {
                        app.realCity.name = cityName;
                    }
                    if ('undefined' === typeof runCallback) {
                        runCallback = true;
                    }
                    $.post('/site/set-city', {
                        city: cityName,
                        real: isReal ? 1 : ''
                    }, function (data) {
                        if (runCallback) {
                            if (isReal && data.real) {
                                app.realCity = data.real;
                            }
                            if (data.city) {
                                app.city = data.city;
                                // onLocation analog
                                _this4.onAfterSetCity();
                            }
                        }
                    }, 'json');
                }

                /**
                 * Обработчики, геолокация
                 */

            }, {
                key: "init",
                value: function init() {}

                /**
                 * @param {number} cityId
                 * @param {boolean} onlyContacts
                 * @protected
                 */

            }, {
                key: "fitSiteToCity",
                value: function fitSiteToCity(cityId, onlyContacts) {}

                /**
                 * Показывает подтверждение определения города
                 * @param {number} cityId
                 * @protected
                 */

            }, {
                key: "showDetectedCityConfirm",
                value: function showDetectedCityConfirm(cityId) {}
            }, {
                key: "isLocationConfirmPromptShown",
                value: function isLocationConfirmPromptShown() {
                    return true;
                }
            }, {
                key: "onAfterSetCity",
                value: function onAfterSetCity() {}
            }, {
                key: "initializePixel",
                value: function initializePixel(realCityName) {
                    if (!pixelTracker.exist(realCityName)) {
                        realCityName = this.getDefaultCity().name;
                    }
                    pixelTracker.init(realCityName);
                }

                /**
                 * Алматы
                 * @return {CityItem}
                 */

            }, {
                key: "getDefaultCity",
                value: function getDefaultCity() {
                    return this.findById(CITY_ALMATY);
                }
            }]);

            return BaseCitySelect;
        }();

        module.exports = BaseCitySelect;
    }, { "./CityItem": 3, "./Location": 4, "./PixelTracker": 5 }], 3: [function (require, module, exports) {
        var CityItem = function () {
            function CityItem(city) {
                _classCallCheck(this, CityItem);

                /** {number} */
                this.id = Number(city.id);
                /** {string} */
                this.name = city.name;
                /** {number|null} */
                this.depart_id = city.depart_id ? Number(city.depart_id) : null;
                /** {boolean} */
                this.scheme = city.scheme; // Схема проезда
                /** {boolean} */
                this.contactsHidden = city.contactsHidden;
                this.currentPhone = {
                    phone: city.currentPhone.phone,
                    href: city.currentPhone.href,
                    linkHtml: city.currentPhone.linkHtml,
                    hiddenHtml: city.currentPhone.hiddenHtml
                };
                this.altPhone = {
                    phone: city.altPhone.phone,
                    href: city.altPhone.href,
                    linkHtml: city.altPhone.linkHtml,
                    hiddenHtml: city.altPhone.hiddenHtml
                };
                this.socials = {
                    instagram: city.socials.instagram, // url
                    facebook: city.socials.facebook // url
                };
                /**
                 * @type {{href: string}}
                 */
                this.whatsapp = {
                    href: city.whatsapp.href
                };
                /** {boolean} */
                this.hasHoliday = !!city.hasHoliday;
            }

            /**
             * @param {string} type - alt|current
             * @return {string}
             */


            _createClass(CityItem, [{
                key: "getPhoneView",
                value: function getPhoneView(type) {
                    return type === 'alt' ? this.getAltPhoneView() : this.getCurrentPhoneView();
                }
            }, {
                key: "getCurrentPhoneView",
                value: function getCurrentPhoneView() {
                    return this.contactsHidden ? this.currentPhone.hiddenHtml : this.currentPhone.linkHtml;
                }
            }, {
                key: "getAltPhoneView",
                value: function getAltPhoneView() {
                    return this.contactsHidden ? this.altPhone.hiddenHtml : this.altPhone.linkHtml;
                }

                /**
                 * @private
                 * @param {string} field
                 * @param {number|string} value
                 * @return {*}
                 */

            }], [{
                key: "_findByField",
                value: function _findByField(field, value) {
                    var city = null;
                    for (var i in app.cities) {
                        if (value === app.cities[i][field]) {
                            city = new CityItem(app.cities[i]);
                            break;
                        }
                    }

                    return city;
                }

                /**
                 * @param {string} cityName
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByName",
                value: function findByName(cityName) {
                    return CityItem._findByField('name', cityName);
                }

                /**
                 * @param {number} departId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findByDepartId",
                value: function findByDepartId(departId) {
                    return CityItem._findByField('depart_id', departId);
                }

                /**
                 * @param {number} cityId
                 * @return {CityItem|null}
                 */

            }, {
                key: "findById",
                value: function findById(cityId) {
                    return this.contactExist(cityId) ? new CityItem(app.cities[cityId]) : null;
                }

                /**
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "contactExist",
                value: function contactExist(cityId) {
                    return 'undefined' !== typeof app.cities[cityId];
                }

                /**
                 * @return {CityItem|null}
                 */

            }, {
                key: "getCurrent",
                value: function getCurrent() {
                    var cityItem = null;
                    if (app.city) {
                        var _city2 = this.findById(app.city.id);
                        cityItem = new CityItem(_city2);
                    }

                    return cityItem;
                }
            }]);

            return CityItem;
        }();

        module.exports = CityItem;
    }, {}], 4: [function (require, module, exports) {
        var Location = function () {
            function Location() {
                _classCallCheck(this, Location);

                this.locatedCity = null;
            }

            /**
             * @param {function} callback
             */


            _createClass(Location, [{
                key: "get",
                value: function get(callback) {
                    var _this5 = this;

                    window.ymapGeolocationLoader.load(function () {
                        if (typeof ymaps === 'undefined' || !ymaps.geolocation) {
                            console.log('ymaps undefined, geolocation off');
                        } else if (_this5.locatedCity !== null) {
                            callback(_this5.locatedCity);
                        } else {
                            var self = _this5;
                            ymaps.ready(function () {
                                ymaps.geolocation.get({ provider: 'yandex' }).then(function (result) {
                                    var locatedCity = result.geoObjects.get(0).properties.get('name');
                                    if (locatedCity === 'Нур-Султан (Астана)') {
                                        locatedCity = 'Астана';
                                        console.log('geo changed', locatedCity);
                                    } else {
                                        console.log('geo', locatedCity);
                                    }
                                    self.locatedCity = locatedCity;
                                    callback(locatedCity);
                                });
                            });
                        }
                    });
                }
            }]);

            return Location;
        }();

        module.exports = Location;
    }, {}], 5: [function (require, module, exports) {
        var PixelTracker = function () {
            function PixelTracker() {
                _classCallCheck(this, PixelTracker);

                this.isInitialized = false;
            }

            /**
             * @param {string} realCityName
             * @return {boolean}
             */


            _createClass(PixelTracker, [{
                key: "init",
                value: function init(realCityName) {
                    if (this.isInitialized) {
                        return false;
                    }
                    var pixelId = this.getId(realCityName);
                    if (pixelId !== '') {
                        this.isInitialized = true;
                        !function (f, b, e, v, n, t, s) {
                            if (f.fbq) return;
                            n = f.fbq = function () {
                                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                            };
                            if (!f._fbq) f._fbq = n;
                            n.push = n;
                            n.loaded = !0;
                            n.version = '2.0';
                            n.queue = [];
                            t = b.createElement(e);
                            t.async = !0;
                            t.src = v;
                            s = b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t, s);
                        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', pixelId); // Insert your pixel ID here.
                        fbq('track', 'PageView');
                    }
                    var srcId = null;
                    if (window.app.updateSourceId !== undefined) {
                        srcId = window.app.updateSourceId;
                    } else if (!document.referrer) {
                        srcId = 33;
                    }
                    if (srcId !== null) {
                        $.get('/site/updateCounter', {
                            src_id: srcId,
                            city_id: window.app.city.id
                        });
                    }
                    return true;
                }

                /**
                 * @param {string} realCityName
                 * @return {string}
                 */

            }, {
                key: "getId",
                value: function getId(realCityName) {
                    var pixelId = '';
                    switch (realCityName) {
                        case 'Алматы':
                            //
                            pixelId = '222300428196785';
                            break;
                        case 'Нур-Султан (Астана)':
                        case 'Нур-Султан':
                        case 'Астана':
                            pixelId = '718486491649332';
                            break;
                        case 'Актобе':
                            //
                            pixelId = '480493949032847';
                            break;
                    }

                    return pixelId;
                }

                /**
                 * @param {string} realCityName
                 * @return {boolean}
                 */

            }, {
                key: "exist",
                value: function exist(realCityName) {
                    return this.getId(realCityName) !== '';
                }
            }]);

            return PixelTracker;
        }();

        module.exports = new PixelTracker();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * Created by vikf on 16.10.15.
         */
        window.img_load = '<img src="/img/load.gif">';
        city = '';
        new_short_id = true;

        // first handlers
        (function () {
            // prevent anchor click
            $('body').on('click', 'a[href="#"]', function (e) {
                e.preventDefault();
            });
        })();

        /**
         * @param {string|null} tourId
         * @param {int|null} hotelId
         */
        window.showHotelInfoModal = function (tourId) {
            var hotelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (tourId || hotelId) {
                var viewUrl = window.app.urls.tourView + (tourId ? 'tour=' + tourId : 'hotel=' + hotelId);
                popup2({
                    page_url: viewUrl,
                    width: 840
                });

                return true;
            }

            return false;
        };

        var MODAL_THEME_DEFAULT = 'default';
        var MODAL_THEME_AIRPLANES = 'airplanes';
        var MODAL_THEME_TRANSPARENT = 'transparent';
        var i18nSubscribeFormMessages = window.subscribeFormJsMessages.i18nSubscribeFormMessages;

        window.bs3popup = function (params) {
            var $popup = $("#bspopup");

            removeAllMapsInElement($popup);

            var availableThemes = [MODAL_THEME_DEFAULT, MODAL_THEME_AIRPLANES, MODAL_THEME_TRANSPARENT];

            if ('string' == typeof params) {
                $popup.modal(params);
                return;
            }
            var url = params.hasOwnProperty('page_url') ? params.page_url : null,
                data = params.hasOwnProperty('data') ? params.data : {},
                height = params.hasOwnProperty('height') ? params.height : null,
                width = params.hasOwnProperty('width') ? params.width : null,
                content = params.hasOwnProperty('content') ? params.content : null,
                theme = params.hasOwnProperty('theme') ? params.theme : '';
            var onAfterShow = params.hasOwnProperty('onAfterShow') && typeof params.onAfterShow === 'function' ? params.onAfterShow : null;
            var removeBodyPadding = params.hasOwnProperty('removeBodyPadding') ? params.removeBodyPadding : false;

            if (availableThemes.indexOf(theme) === -1) {
                theme = MODAL_THEME_DEFAULT;
            }
            if (params.transparent) {
                theme = MODAL_THEME_TRANSPARENT;
            }

            if (params.hasOwnProperty('hash') && params.hash) document.location.hash = params.hash;

            var $dialog = $popup.find('.modal-dialog'),
                $body = $popup.find('.modal-body'),
                $content = $popup.find('.modal-content');

            $body.toggleClass('no-padding', removeBodyPadding);

            var $contentPlace = $body;
            if (theme === MODAL_THEME_AIRPLANES) {
                if (width) {
                    width = 910; // +40 below
                }
                $body.html('<div class="modal-airplanes-bg">' + '<div class="modal-airplanes-bg-decoration"></div>' + '</div>' + '<div class="modal-airplanes-content"><div class="modal-airplanes-body"></div></div>');
                $contentPlace = $body.find('.modal-airplanes-body');
            }

            $dialog.removeClass('theme-' + availableThemes.join(' theme-'));
            $dialog.addClass('theme-' + theme);

            $popup.addClass('request-helper');
            $dialog.css('width', '950px');
            if (width) {
                $dialog.css('width', parseFloat(width) + 40 + 'px');
            }
            if (height) {
                $body.css('height', height + 'px');
            } else {
                $body.css('height', 'auto');
            }
            //$popup.removeClass('request-helper');
            $popup.removeClass('subscribe-close').removeClass('success-close').removeClass('request-close');
            $dialog.removeClass('transparent');
            $content.removeClass('transparent');
            if (url) {
                if (data.hasOwnProperty('frame') && parseInt(data['frame'])) {
                    var iframe = document.createElement('iframe');
                    iframe.id = 'htIframe';
                    iframe.style.width = '100%';
                    iframe.style.height = '0px';
                    iframe.style.display = 'none';
                    var $loader = $('<div class="center">' + img_load + ' Подождите, идет загрузка</div>');
                    iframe.onload = function () {
                        var height;
                        var $frame = $("#htIframe");
                        $frame.css('display', 'block');
                        if (data.frameHeight) {
                            height = data.frameHeight;
                        } else {
                            var $contentWrapper = $frame.contents().find(".iframe_form");
                            if (!$contentWrapper.length) {
                                $contentWrapper = $frame.contents().find("body");
                                height = $contentWrapper.outerHeight();
                            } else {
                                height = $contentWrapper.height() + 50;
                            }
                        }
                        $frame.height(height + 'px');
                        $loader.remove();
                    };
                    $contentPlace.html(iframe);
                    $contentPlace.append($loader);
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    iframe.src = url;
                    if (onAfterShow) {
                        onAfterShow($popup);
                    }
                } else {
                    $contentPlace.html("<p class='text-center'><img src='/img/load.gif' /></p>");
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    $.get(url, {}, function (data) {
                        $contentPlace.html(data);
                        if (onAfterShow) {
                            onAfterShow($popup);
                        }
                        window.tracking.callTrackingRefresh();
                    });
                }
            } else if (content) {
                $contentPlace.html(content);
                $popup.modal({
                    backdrop: true,
                    show: true
                });
                if (onAfterShow) {
                    onAfterShow($popup);
                }
                window.tracking.callTrackingRefresh();
            }
        };
        window.close_popup = function () {
            bs3popup('hide');
        };
        window.popup2 = function (params) {
            bs3popup(params);
        };

        $(document).ready(function () {

            // События для баннера приложения в левом нижнем углу
            var isAppBannerClosed = localStorage.getItem('isAppBannerClosed');
            var $appBanner = $('.app-banner');
            if (window.utils.isLocalStorageSupported && !isAppBannerClosed) {
                setTimeout(function () {
                    $appBanner.removeClass('hidden');
                }, 2000);
            }
            $('.close-app-banner').on('click', function () {
                $appBanner.toggleClass('hidden');
                if (window.utils.isLocalStorageSupported) {
                    localStorage.setItem('isAppBannerClosed', 'true');
                }
            });
            $appBanner.on('click', function () {
                window.location.href = 'https://poedem.onelink.me/OG6g/sk2iuaxc';
                if (window.utils.isLocalStorageSupported) {
                    localStorage.setItem('isAppBannerClosed', 'true');
                }
            });

            // fixed site search form
            var $searchFormWrapper = $('.short-search');
            if ($searchFormWrapper.length && !$searchFormWrapper.hasClass('short-search-theme--vertical')) {
                var fixedSearchFormAfterScrollY = $searchFormWrapper.offset().top + $searchFormWrapper.outerHeight()
                // Отступ для анимации
                + 250;
                var searchFormFixed = false;
                $(window).on('scroll', window.utils.throttle(function (e) {
                    if (e.currentTarget.scrollY > fixedSearchFormAfterScrollY) {
                        if (!searchFormFixed) {
                            searchFormFixed = true;
                            $searchFormWrapper.addClass('fixed');
                        }
                    } else {
                        if (searchFormFixed) {
                            searchFormFixed = false;
                            $searchFormWrapper.removeClass('fixed');
                        }
                    }
                }, 50));
            }

            $('.read-more').on('click', function () {
                var $selfButton = $(this);
                var $parent = $selfButton.closest('.text-preview');
                $parent.addClass('visible');
                $parent.find('.text-hidden').removeClass('text-hidden');
                if (parseInt($selfButton.data('toggle'), 10) !== 1) {
                    $selfButton.remove();
                }
            });

            var $body = $("body");
            var $currencySelect = new hSelect({
                selector: '.currency-select',
                theme: 'easy',
                checkWidth: false,
                onChange: function onChange(ui) {
                    $.post('/site/set-currency', { currency: ui.value }).done(function () {
                        window.location.reload();
                    });
                }
            });

            var languageSelectWidget = new hSelect({
                selector: '.language-select',
                theme: 'easy',
                checkWidth: false,
                onChange: function onChange(languageSelect) {
                    $.post('/settings/set-language', { language: languageSelect.value }).done(function () {
                        window.location.reload();
                    });
                }
            });

            // Блок с pop-up для языка
            var $popUpLanguageBlock = $('.language-pop-up-info-block');
            var $languageSelect = $('.language-select');
            var $closeButton = $popUpLanguageBlock.find('.close-button');
            // Проверяем, есть ли запись в localStorage о том, что блок был закрыт
            var isPopUpClosed = window.utils.isLocalStorageSupported ? localStorage.getItem('popUpForLanguageClosed') : null;
            // Если блок не закрывали, то показываем его через 1 секунду
            if (!isPopUpClosed) {
                setTimeout(function () {
                    $popUpLanguageBlock.css('display', 'block');
                    // Обработчик события клика на кнопку закрытия
                    $closeButton.one('click', function () {
                        // Закрываем блок
                        $popUpLanguageBlock.css('display', 'none');
                        // Записываем информацию в localStorage о том, что блок был закрыт
                        localStorage.setItem('popUpForLanguageClosed', 'true');
                    });
                    // Если не закрывают, а выбирают сразу язык тоже закроем
                    $languageSelect.one('click', function () {
                        // Закрываем блок
                        $popUpLanguageBlock.css('display', 'none');
                        // Записываем информацию в localStorage о том, что блок был закрыт
                        localStorage.setItem('popUpForLanguageClosed', 'true');
                    });
                }, 1000);
            }

            function subscriptionSuccess(isOpen, onAfterOpen) {
                var $popup = $("#bspopup");
                var url = '/subscription-success';
                var $dialog = $popup.find('.modal-dialog'),
                    $body = $popup.find('.modal-body'),
                    $content = $popup.find('.modal-content');
                $popup.addClass('success-close').removeClass('subscribe-close').removeClass('request-close');
                if (!isOpen) {
                    $popup.addClass('request-helper');
                    $dialog.css('width', '950px');
                    $body.css('height', 'auto');
                    $content.addClass('transparent');
                    $body.html("<p class='text-center'><img src='/img/load.gif' /></p>");
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                } else {
                    $body.hide();
                }
                $.get(url, {}, function (data) {
                    if (!isOpen) {
                        $body.html(data);
                    } else {
                        $body.html(data).show();
                    }
                    if (typeof onAfterOpen === 'function') {
                        onAfterOpen($body.children(':first-child'));
                    }
                });
            }

            function errorReportingSuccess() {
                var $popup = $("#bspopup");
                var url = '/error-reporting-success';
                var $body = $popup.find('.modal-body');
                $popup.addClass('subscribe-close').removeClass('success-close').removeClass('request-close');
                $body.hide();
                $.get(url, {}, function (data) {
                    $body.html(data).show();
                });
            }

            function handlers() {
                $body.on('click', '.popup', function (e) {
                    e.preventDefault();
                    var link = '';
                    var $self = $(this);
                    if ($self.attr('data-href')) {
                        link = $self.attr('data-href');
                    } else {
                        link = $self.attr('alt');
                    }
                    bs3popup({
                        page_url: link,
                        width: $self.data('width') ? $self.data('width') : $self.attr('rel'),
                        hash: $self.data('hash'),
                        data: $self.data()
                    });
                }).on('click', '.close_popup', close_popup).on('click', '.show-hotel-info', function (e) {
                    e.preventDefault();
                    var $target = $(this);
                    var $dataSource = $target.closest('.js-tour-view-data');
                    var tourData = $dataSource.data();

                    var tourId = tourData.id || null;
                    var hotelId = tourData.hotelId || null;
                    window.showHotelInfoModal(tourId, hotelId);
                    e.stopPropagation();
                }).on('click', '.bigImg_wrap_left, .bigImg_wrap_right', function (e) {
                    e.preventDefault();
                    var $elem = $('#bigImg'),
                        dir = 1,
                        new_index = 0;
                    var $blurBg = $('.blur-bg');
                    var data = $elem.data();
                    if ($(this).hasClass('bigImg_wrap_left')) {
                        dir = -1;
                    }
                    new_index = data.cur + dir > data.max ? data.cur + dir - data.max - 1 : data.cur + dir;
                    if (data.cur + dir < 0) {
                        new_index = data.max;
                    }
                    slideGallery(new_index, data.max);
                    var tpl = '.images div:eq({index})';
                    $img = $(tpl.replace('{index}', new_index));

                    $elem.attr('src', $img.data('big')).data('cur', $img.data('index'));
                    $blurBg.css('background-image', 'url("' + $img.data('big') + '")');
                    $('#previewImagesWrap div.active').removeClass('active');
                    $img.addClass('active');
                    $(".bigImg_counter").text($elem.data('cur') + 1 + "/" + ($elem.data('max') + 1));
                }).on('click', '#previewImagesWrap div', function (e) {
                    var bigImg = $('#bigImg');
                    var $blurBg = $('.blur-bg');
                    bigImg.attr('src', $(this).data('big')).data('cur', $(this).data('index'));
                    $blurBg.css('background-image', 'url("' + $(this).data('big') + '")');
                    //
                    slideGallery($(this).data('index'), bigImg.data("max"));
                    //
                    $('#previewImagesWrap div.active').removeClass('active');
                    $(this).addClass('active');
                    $("#bigImg_counter").text(bigImg.data('cur') + 1 + "/" + (bigImg.data('max') + 1));
                }).on('click', '#tour_contacts .city-toggle', function (e) {
                    e.preventDefault();
                    var t = $(this);
                    var city = t.data('city-id');
                    $('#tour_contacts .city-toggle').removeClass('active-city');
                    t.addClass('active-city');
                    $('#tour_contacts .city-map').removeClass('active-map');
                    $('#tour_contacts .city-contacts').removeClass('active-map');
                    $('#tour_contacts .city-map[data-city-id="' + city + '"]').addClass('active-map');
                    $('#tour_contacts .city-contacts[data-city-id="' + city + '"]').addClass('active-map');
                }).on('click', '.office-scheme-toggle', function (e) {
                    e.preventDefault();
                    popup2({
                        page_url: '/scheme/' + $(this).data('city')
                    });
                    window.tracking.setYaEvent('click.officeScheme');
                    window.tracking.setGAEvent('officeScheme', 'click');
                })
                // При закрытии модального окна очищаем созданные объекты карт
                // Работает для всплывашек схемы проезда и всплывашек с инфо об отеле
                .on('hidden.bs.modal', '#bspopup', function (e) {
                    window.removeAllMapsInElement($('#bspopup'));
                    new_short_id = true;
                }).on('click', '.hot-subscribe-popup', function (e) {
                    e.preventDefault();
                    var $popup = $("#bspopup");
                    var url = $(this).data('url');
                    var $dialog = $popup.find('.modal-dialog'),
                        $body = $popup.find('.modal-body'),
                        $content = $popup.find('.modal-content'),
                        $close = $popup.find('.close');
                    $popup.addClass('request-helper');
                    $dialog.css('width', '950px');
                    $body.css('height', 'auto');
                    $content.addClass('transparent');
                    $body.html("<p class='text-center'><img src='/img/load.gif' /></p>");
                    $popup.addClass('subscribe-close').removeClass('success-close').removeClass('request-close');
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    $.get(url, {}, function (data) {
                        $body.html(data);
                    });
                }).on('click', '.subscribe-btn', function (e) {
                    e.preventDefault();
                    // var token = $('meta[name=csrf-token]').attr("content");
                    var block = $(this).closest('div .subscription-control');
                    var $eml = block.find('.subscription-control-form .subscription-email-validate');
                    var result = block.find('.subscription-result');
                    var loading = block.find('.subscription-loading');
                    var email = $eml.val();
                    var popup = $(this).hasClass('popup-subscribe-btn');
                    var radioCity = block.find('.subscription-city-control:checked');
                    var isMobile = $(this).hasClass('mobile-subscribe');
                    var form;
                    if (isMobile) {
                        form = block.find('.subscription-control-form');
                    } else {
                        form = block.find('.mobile-form-wrapper');
                    }

                    if (email === "") {
                        console.log('empty email');
                        $eml.focus();
                        $eml.tooltip({
                            trigger: 'manual',
                            placement: 'top',
                            title: i18nSubscribeFormMessages.enterYourEmail
                        }).tooltip('show');
                        setTimeout(function () {
                            $eml.tooltip('hide');
                        }, 2500);
                        return;
                    }
                    var url = '/subscription';
                    var params = {
                        // '_csrf': token,
                        'email': email,
                        'city': radioCity.val()
                    };

                    form.addClass('hide');
                    result.addClass('hide');
                    loading.removeClass('hide');

                    $.post(url, params, function (data) {
                        loading.addClass('hide');
                        var dataResult = JSON.parse(data);
                        if (dataResult.success) {
                            var conversion = window.tracking.formConversion;
                            if (isMobile) {
                                // deprecated. OLD tours req page only
                                result.text(dataResult.message).removeClass('hide');
                                var analyticElement = result[0];
                                conversion.markSubscription(analyticElement, true);
                            } else {
                                form.removeClass('hide');
                                subscriptionSuccess(popup, function ($lazyResult) {
                                    var analyticElement = $lazyResult[0];
                                    conversion.markSubscription(analyticElement, true);
                                });
                            }
                            // DEPRECATED!
                            window.tracking.setYaEvent('subscribe.hotOffersSuccess');
                            window.tracking.setGAEvent('hotOffers', 'subscribe');
                        } else {
                            $eml.focus();
                            $eml.val('');
                            $eml.prop('placeholder', dataResult.message);
                            form.removeClass('hide');
                            $eml.trigger('focus');
                        }
                    });
                }).on('click', '.tour_tab_link', function () {
                    $('#formCalendar div.month-picture div.month-title_wrapper').hide();
                    $('#tours-preloader .preloader-span').html(i18nSubscribeFormMessages.pleaseWait);
                    $('#tours-preloader').show();
                }).on('click', '.error-reporting-button', function (e) {
                    e.preventDefault();
                    var $popup = $("#bspopup");
                    var url = '/error-reporting';
                    var $dialog = $popup.find('.modal-dialog'),
                        $body = $popup.find('.modal-body'),
                        $content = $popup.find('.modal-content'),
                        $close = $popup.find('.close');
                    $popup.addClass('request-helper');
                    $dialog.css('width', '950px');
                    $body.css('height', 'auto');
                    $content.addClass('transparent');
                    $body.html("<p class='text-center'><img src='/img/load.gif' /></p>");
                    $popup.addClass('subscribe-close').removeClass('success-close').removeClass('request-close');
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                    $.get(url, {}, function (data) {
                        $body.html(data);
                    });
                }).on('click', '.error-report-button', function (e) {
                    e.preventDefault();
                    var send = true,
                        $email = $('#error-email'),
                        emailValue = $email.val(),
                        $message = $('#error-message'),
                        messageValue = $message.val(),
                        pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i,
                        url = '/error-add';
                    if (!messageValue.length) {
                        $message.addClass('error-reporting-error');
                        $message.tooltip({
                            trigger: 'manual',
                            placement: 'top',
                            title: i18nSubscribeFormMessages.describeTheIssue
                        }).tooltip('show');
                        setTimeout(function () {
                            $message.tooltip('hide');
                        }, 2500);
                        send = false;
                    }
                    if (!emailValue.length || emailValue.length && !pattern.test(emailValue)) {
                        $email.addClass('error-reporting-error');
                        $email.tooltip({
                            trigger: 'manual',
                            placement: 'top',
                            title: i18nSubscribeFormMessages.writeYourEmail
                        }).tooltip('show');
                        setTimeout(function () {
                            $email.tooltip('hide');
                        }, 2500);
                        send = false;
                    }
                    if (send) {
                        $.post(url, { message: messageValue, email: emailValue }, function () {
                            errorReportingSuccess();
                        });
                    }
                }).on('focus', '#error-email, #error-message', function () {
                    $(this).removeClass('error-reporting-error');
                }).on('click', '.hotel-info_description .more-info', function (e) {
                    e.preventDefault();
                    var that = $(this);
                    if (that.hasClass('isOpen')) {
                        that.html('Подробнее об отеле').removeClass('isOpen').prev('p').css('height', '54px');
                    } else {
                        that.html('Скрыть').addClass('isOpen').prev('p').css('height', 'auto');
                    }
                }).on('click', '.tab-content-hotel .info .tour-info button', function (e) {
                    e.preventDefault();
                    $('#hotTabs1 a[href="#hotel_buy"]').tab('show');
                    $('.modal-body').animate({ scrollTop: 0 }, 2000);
                }).on('click', '.js-popup', function (e) {
                    e.preventDefault();
                    return false;
                }).on('click', '.show-hidden-phone', function () {
                    window.utils.showHiddenPhone(this);
                    window.tracking.setYaEvent('click.hiddenPhone');
                    window.tracking.setGAEvent('hiddenPhone', 'click');
                });

                if (app && app.isMobile) {
                    // for now one event is enough
                    $body.one('click', '.js-clickable-phone', function () {
                        window.tracking.setYaEvent('click.onPhone');
                        window.tracking.setGAEvent('sitePhone', 'click');
                    });
                }

                // Событие при загрузке схемы проезда. Обходим все офисы в городе и инициализируем для них яндекс карту
                $(window).on('schemeLoad', function (e) {
                    $('#modal_scheme .modal_scheme').each(function () {
                        var $self = $(this);
                        var mapExist = $self.data('map-exists') === 1;
                        if (!mapExist) {
                            $self.data('map-exists', 1);
                            var map_id = 'office-scheme-' + $self.data('office-id');
                            var hint = $self.data('office-hint');
                            var lon = $self.data('office-lon');
                            var lat = $self.data('office-lat');
                            var map = new OfficeSchemeMap(map_id, lon, lat, hint);
                            map.init();
                        }
                    });
                });

                $('ul.nav li.dropdown').hover(function (e) {
                    if ($(this).hasClass('menu-item_hotoffers') && window.citySelect.isMainMenuOpenLocked()) {
                        return;
                    }
                    $(this).find('.dropdown-menu').stop(true, true).delay(40).fadeIn(1);
                }, function () {
                    $(this).find('.dropdown-menu').stop(true, true).delay(40).hide();
                });
            }

            handlers();
        });

        $(window).on('load', function () {
            $('.lazy').lazy({
                bind: "event",
                delay: 0
            });
        });

        // jQuery.cookie = function (e, i, o) {
        //     if ("undefined" == typeof i) {
        //         var n = null;
        //         if (document.cookie && "" != document.cookie)
        //             for (var r = document.cookie.split(";"), t = 0; t < r.length; t++) {
        //                 var p = jQuery.trim(r[t]);
        //                 if (p.substring(0, e.length + 1) == e + "=") {
        //                     n = decodeURIComponent(p.substring(e.length + 1));
        //                     break
        //                 }
        //             }
        //         return n
        //     }
        //     o = o || {}, null === i && (i = "", o.expires = -1);
        //     var u = "";
        //     if (o.expires && ("number" == typeof o.expires || o.expires.toUTCString)) {
        //         var s;
        //         "number" == typeof o.expires ? (s = new Date, s.setTime(s.getTime() + 24 * o.expires * 60 * 60 * 1e3)) : s = o.expires, u = "; expires=" + s.toUTCString()
        //     }
        //     var a = o.path ? "; path=" + o.path : "",
        //         c = o.domain ? "; domain=" + o.domain : "",
        //         m = o.secure ? "; secure" : "";
        //     document.cookie = [e, "=", encodeURIComponent(i), u, a, c, m].join("")
        // };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).ready(function () {
            var allowAutoQuizShow = window.app.features.tourQuizEnabled === 1 && window.disableQuiz !== 1 && window.utils.cookies.get('modal_quiz_form_shown') !== '1';
            function isSomePopupShown() {
                return $('.modal.in').length > 0 // any modal visible now
                || $('#push-popover.timer-enabled').length // push subscribe prompt timer enabled
                || window.citySelect && window.citySelect.isLocationConfirmPromptEnabled(); // location prompt enabled
            }

            function showModalQuizForm() {
                if (!allowAutoQuizShow || isSomePopupShown()) {
                    return false;
                }
                allowAutoQuizShow = false; // Отключить в рамках текущего визита
                window.utils.cookies.set('modal_quiz_form_shown', 1, {
                    expires: 24 * 60 * 60,
                    path: '/'
                });

                popup2({
                    page_url: '/quiz/tour',
                    transparent: true,
                    width: 550
                });
            }

            if (allowAutoQuizShow) {
                $('body').on('mouseleave', function (event) {
                    if (event.clientY < 10) {
                        showModalQuizForm();
                    }
                });
            }
        });
    }, {}] }, {}, [1]);